export default __webpack_public_path__ + "static/media/video_active.3a477814.svg";